module.exports = __webpack_public_path__ + "static/media/behance-logo.9de48ea5.svg";